import frontDesk from '@/locales/es/frontDesk/frontDesk.locales';

export default {
    ...frontDesk,
};
